import { GAService } from '../../../utils/services'
import { APP_ACTION, doDataLayerEvent } from '../../../utils/services/googleAnalytics'
import { APP_CONFIG } from './constants'

const appEventName = GAService.getAppEventName(APP_CONFIG.appCode)

export const handleDataLayerEvent = ({ appAction, appInputs, appOutputs }) => {
  const payload = Object.assign({
    app_name: appEventName,
    app_action: appAction,
    solution_found:
      appAction === APP_ACTION.UPLOAD
        ? 'N/A'
        : appOutputs && appOutputs.data.summary && appOutputs.data.summary.length > 0
        ? 'Yes'
        : 'No',
    inputs: appInputs,
  })
  doDataLayerEvent(payload)
}
